/**
 * LoginBanner - Banner displayed when the user is not authenticated
 * Invites the user to sign in via centralized auth
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginBanner.css';

const LoginBanner = ({ onLoginClick }) => {
  const { currentUser, guestMode, redirectToAuth } = useAuth();

  if (currentUser) return null;

  const handleLoginClick = () => {
    redirectToAuth('login');
  };

  return (
    <div className="login-banner">
      {guestMode && (
        <span className="login-banner-text">
          Mode invité — vos données sont sauvegardées localement uniquement.
        </span>
      )}
      <button className="login-banner-btn" onClick={handleLoginClick}>
        <i className="bi bi-box-arrow-in-right me-1"></i>
        Se connecter
      </button>
    </div>
  );
};

export default LoginBanner;
